/**
 * Carousel Core Utilities
 * Shared utilities and base classes for all carousel functionality
 * Optimized for performance and reusability
 */

let carouselInitCount = 0;
const maxInitTime = 2000;

function logCarouselInit(name) {
  carouselInitCount++;
  console.log(`Carousel initialized: ${name} (${carouselInitCount})`);
}

// Global resize handler to prevent multiple listeners (LEGACY - for existing carousels)
let globalResizeTimer;
let globalResizeHandlers = [];

function addGlobalResizeHandler(handler) {
  globalResizeHandlers.push(handler);
}

function removeGlobalResizeHandler(handler) {
  const index = globalResizeHandlers.indexOf(handler);
  if (index > -1) globalResizeHandlers.splice(index, 1);
}

function triggerGlobalResize() {
  clearTimeout(globalResizeTimer);
  globalResizeTimer = setTimeout(() => {
    globalResizeHandlers.forEach(handler => {
      try { handler(); } catch(e) { console.warn('Resize handler error:', e); }
    });
  }, 250); // Increased from 100ms to 250ms to reduce frequency
}

// Single global resize listener
window.addEventListener('resize', triggerGlobalResize);
window.addEventListener('orientationchange', () => {
  // Immediate trigger for orientation change
  globalResizeHandlers.forEach(handler => {
    try { handler(); } catch(e) { console.warn('Orientation handler error:', e); }
  });
});

// Image lazy loading for carousels
function lazyLoadCarouselImages() {
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            observer.unobserve(img);
          }
        }
      });
    }, {
      rootMargin: '50px 0px', // Start loading 50px before image comes into view
      threshold: 0.1
    });

    // Observe all carousel images
    document.querySelectorAll('.fandom-brands-blocks-container img, .mini-hero img, .landscape-cards img, .top10 img').forEach(img => {
      if (img.dataset.src) {
        imageObserver.observe(img);
      }
    });
  }
}

// Intersection Observer for carousel initialization
function initCarouselIntersectionObserver() {
  if ('IntersectionObserver' in window) {
    const carouselObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const carousel = entry.target;
          // Trigger carousel initialization if not already done
          if (carousel.classList.contains('js-hero-carousel') && !carousel.classList.contains('slick-initialized')) {
            // Initialize hero carousel
            if (window.jQuery && jQuery.fn && jQuery.fn.slick) {
              const $carousel = jQuery(carousel);
              const carouselOptions = $carousel.data('slick');
              if (carouselOptions) {
                $carousel.slick(carouselOptions);
                console.log('Hero carousel initialized via intersection observer');
              }
            }
          }
          if (carousel.classList.contains('js-mini-hero-slider') && !carousel.classList.contains('slick-initialized')) {
            // Mini Hero carousel will initialize via its own observer
          }
          if (carousel.classList.contains('js-landscape-cards') && !carousel.classList.contains('slick-initialized')) {
            // RSVLTS Classic carousel will initialize via its own observer
          }
          if (carousel.classList.contains('js-top10-slider') && !carousel.classList.contains('slick-initialized')) {
            // Top-10 carousel will initialize via its own observer
          }
        }
      });
    }, {
      rootMargin: '100px 0px', // Start initialization 100px before carousel comes into view
      threshold: 0.1
    });

    // Observe all carousel containers
    document.querySelectorAll('.js-hero-carousel, .js-mini-hero-slider, .js-landscape-cards, .js-top10-slider').forEach(carousel => {
      carouselObserver.observe(carousel);
    });
  }
}


// Initialize lazy loading and carousel observers when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  lazyLoadCarouselImages();
  initCarouselIntersectionObserver();

  // Mark as fully initialized
  window.CarouselCore.isInitialized = true;

  // Trigger any pending initialization callbacks
  if (window.CarouselCore.pendingCallbacks) {
    window.CarouselCore.pendingCallbacks.forEach(callback => {
      try { callback(); } catch(e) { console.warn('CarouselCore callback error:', e); }
    });
    window.CarouselCore.pendingCallbacks = [];
  }
});


// Export for use in other modules
window.CarouselCore = {
  isInitialized: false,
  pendingCallbacks: [],
  logCarouselInit,
  addGlobalResizeHandler,
  removeGlobalResizeHandler,
  triggerGlobalResize,
  lazyLoadCarouselImages,
  initCarouselIntersectionObserver,

  // Method to wait for full initialization
  waitForInitialization(callback) {
    if (this.isInitialized) {
      callback();
    } else {
      this.pendingCallbacks.push(callback);
    }
  }
};
